import { render, staticRenderFns } from "./CityMapTitle.vue?vue&type=template&id=a20a20d2&scoped=true&"
import script from "./CityMapTitle.vue?vue&type=script&lang=js&"
export * from "./CityMapTitle.vue?vue&type=script&lang=js&"
import style0 from "./CityMapTitle.vue?vue&type=style&index=0&id=a20a20d2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a20a20d2",
  null
  
)

export default component.exports